<div class="col" #container>
</div>



// WEBPACK FOOTER //
// ./src/app/hdrthumbnail/hdrthumbnail.component.html